import WordPuzzlePage from "@components/Modules/Kuiz/WordPuzzle";
import { getGTMData, getMetaData } from "@helper/getMetaData";
import BHBasePage, { BHBasePageProps } from "@routes/BHBasePage";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";

import KuizMetaData from "./KuizMetaData";

export function meta() {
  return [getMetaData(KuizMetaData({ title: "Kuiz BH" }).metaTags)];
}

export default function KuizPage() {
  const sectionName = "kuiz-bh";
  const kuizPageProps: BHBasePageProps = {
    uniqueSectionName: sectionName,
    pageAdTargetValue: PageAdTargetingTypeEnum.LISTING,
  };

  return (
    <BHBasePage {...kuizPageProps}>
      <WidgetWrapper className="px-0">
        <div className="flex flex-col w-full -mt-xs lg:mt-[17px]">
          <span className="hidden lg:block text-blue-100 text-lg font-bold mb-xs">
            Kuiz BH
          </span>
          <div className="w-full lg:pt-sm">
            <WordPuzzlePage />
          </div>
        </div>
      </WidgetWrapper>
    </BHBasePage>
  );
}

import { ResponseType, TRouteWithRedirect } from "@sphtech/web2-core/ssr";

export function loader(): Promise<TRouteWithRedirect<object | null, string>> {
  const { gaData } = KuizMetaData({ title: "Kuiz BH" });

  return Promise.resolve({
    type: ResponseType.SUCCESS,
    statusCode: 200,
    payload: null,
    gtm: getGTMData(gaData),
  });
}
